module.exports = "https://r.zoocdn.com/_next/static/images/newhome-9e6698a9a8cad1bb71d0ff1a4fc1126d.jpeg";